import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';

const EditPartnerFooter = ({
  onClickNext,
  step,
  disabled,
  loading
}: {
  onClickNext: () => void;
  onClickSkip: () => void;
  step: number;
  disabled: boolean;
  loading?: boolean;
}) => {
  return (
    <div>
      {step <= 1 && (
        <Button
          small
          color='primary'
          variant='block'
          className='mx-auto'
          onClick={onClickNext}
          disabled={disabled}
          loading={loading}>
          {loading ? 'Updating' : 'Next'}
        </Button>
      )}

      {step === 2 && (
        <Button
          small
          color='primary'
          variant='block'
          className='mx-auto'
          onClick={onClickNext}
          disabled={disabled}
          loading={loading}>
          {loading ? 'Updating' : 'Confirm'}
        </Button>
      )}
    </div>
  );
};

export default EditPartnerFooter;
